import { NotificationsOutlined } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { Markdown } from "@pimo/pimo-app-builder";

export interface NotificationItem {
  id: string | number;
  title?: string;
  text?: string;
  createdAt?: string;
}

interface NotificationContentProps {
  notification: NotificationItem;
  onClick?: () => void;
}

const isSameOriginLink = (href?: string): boolean => {
  if (!href || typeof window === "undefined") {
    return false;
  }

  try {
    return (
      new URL(href, window.location.href).origin === window.location.origin
    );
  } catch {
    return false;
  }
};

export const NotificationContent = ({
  notification,
  onClick,
}: NotificationContentProps) => (
  <Box
    sx={{ display: "flex", gap: 2, p: 2, color: "text.primary" }}
    onClick={onClick}
  >
    <NotificationsOutlined sx={{ color: "primary.main" }} />
    <Box sx={{ flex: 1 }}>
      <Typography variant="h6" sx={{ mb: 1 }}>
        {notification.title}
      </Typography>
      <Typography variant="body2" component="div" sx={{ mb: 1 }}>
        {/* markdown, like the banner: allows links in the text */}
        <Markdown
          inline
          fontSizeRelativeTo="parent"
          components={{
            a: ({ href, children, ...props }) => (
              <a
                {...props}
                href={href}
                target={isSameOriginLink(href) ? "_self" : props.target}
              >
                {children}
              </a>
            ),
          }}
        >
          {notification.text ?? ""}
        </Markdown>
      </Typography>
      {notification.createdAt && (
        <Typography variant="caption" color="text.secondary">
          {new Date(notification.createdAt).toLocaleString()}
        </Typography>
      )}
    </Box>
  </Box>
);
